import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FormattedMessage as T, useIntl } from "react-intl";
import useBoolean from "hooks/useBoolean";
import { ReactNode, useState } from "react";
import { Alert } from "@mui/material";
import translateError from "utils/translateError";

const styles = {
  feedback: {
    width: "100%",
    margin: "20px 0 20px 0",
  },
};

type ConfirmDialogProps = {
  dialogTitleKey: string;
  contentKey?: string;
  rawContent?: ReactNode;
  open: boolean;
  confirmLabel?: string | undefined;
  cancelLabel?: string;
  onCancel: () => void;
  handleConfirm: () => Promise<any> | void;
};

const ConfirmDialog = ({
  dialogTitleKey,
  contentKey,
  rawContent,
  open,
  cancelLabel = "cancelButton",
  confirmLabel = "okButton",
  onCancel,
  handleConfirm,
}: ConfirmDialogProps) => {
  const [confirming, confirmingActions] = useBoolean(false);
  const [error, setError] = useState();
  const { formatMessage: t } = useIntl();
  const confirmExec = async () => {
    try {
      setError(undefined);
      confirmingActions.setTrue();
      await handleConfirm();
    } catch (error) {
      setError(translateError(error, t));
    } finally {
      confirmingActions.setFalse();
    }
  };

  return (
    <div>
      <Dialog open={open} disableEnforceFocus onClose={onCancel}>
        <DialogTitle>
          <T id={dialogTitleKey!} />
        </DialogTitle>
        <DialogContent dividers>
          {!!contentKey && (
            <T
              id={contentKey}
              values={{
                linebreak: (
                  <>
                    <br />
                    <br />
                  </>
                ),
              }}
            />
          )}
          {rawContent}
          {error && (
            <Alert sx={styles.feedback} severity="error">
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={onCancel}
            color="primary"
            disabled={confirming}
          >
            <T id={cancelLabel} />
          </Button>
          <Button
            onClick={confirmExec}
            color="primary"
            disabled={confirming}
            startIcon={confirming && <CircularProgress size={16} />}
          >
            <T id={confirmLabel} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmDialog;
